var _rect, _rect2, _rect3, _rect4, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboveFoldPlacementIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 140,
    viewBox: "0 0 183 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 32,
    width: 66,
    height: 52,
    fill: "#DAD8DA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 32,
    width: 66,
    height: 52,
    fill: "#DAD8DA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 92,
    width: 16,
    height: 16,
    fill: "#EFEEEF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 92,
    width: 120,
    height: 16,
    fill: "#EFEEEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 88H175",
    stroke: "#6E28FC",
    strokeDasharray: "3 3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboveFoldPlacementIcon);
export default __webpack_public_path__ + "static/media/above-fold-placement-icon.e0bb5fbbaacb7bb19dff8b1e00cf55c2.svg";
export { ForwardRef as ReactComponent };